import {
  ContainerResponse,
  JourneyResponse,
  JourneyWithPositionResponse,
  OccupancyType,
  PositionDto,
} from '@yard/app/api'
import { OcuppancyWithFilterData } from '@yard/stores/OccupancyStore'
import { StackedInResponse } from '../models/occupancy.model'

export const mapJourneyWithPositionToOccupancy = (
  jwp: JourneyWithPositionResponse,
  position?: PositionDto,
  type?: OccupancyType,
): OcuppancyWithFilterData => ({
  ...jwp,
  ...jwp.journey,
  ...jwp.journey.container,
  journeyId: jwp.journey.id,
  position,
  type,
  containerNumber: jwp.journey.container?.containerNumber ?? '',
  isDamaged: jwp.journey.container?.isDamaged ?? false,
})

export const mapStackedInOccupancyToOccupancy = (
  upsertedOccupancy: StackedInResponse,
  updatedJourney: JourneyResponse,
): OcuppancyWithFilterData => ({
  ...upsertedOccupancy,
  ...updatedJourney,
  ...updatedJourney.container,
  journeyId: updatedJourney.id,
  type: OccupancyType.Occupied,
  containerNumber: updatedJourney.container?.containerNumber ?? '',
  isDamaged: updatedJourney.container?.isDamaged ?? false,
})

export const mapJourneyUpdateToOccupancy = (
  occupancy: OcuppancyWithFilterData,
  updatedJourney: JourneyResponse,
): OcuppancyWithFilterData => ({
  ...occupancy,
  ...updatedJourney,
  ...updatedJourney.container,
  journeyId: updatedJourney.id,
  containerNumber: updatedJourney.container?.containerNumber ?? '',
  isDamaged: updatedJourney.container?.isDamaged ?? false,
  type: occupancy.type,
})

export const mapContainerUpdateToOccupancy = (
  occupancy: OcuppancyWithFilterData,
  updatedContainer: ContainerResponse,
): OcuppancyWithFilterData => ({
  ...occupancy,
  ...updatedContainer,
  containerNumber: updatedContainer.containerNumber,
  isDamaged: updatedContainer.isDamaged,
})
